// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__Wk+MU","navbar-item":"navbar_navbar-item__x3IB1","navbar-item--active":"navbar_navbar-item--active__aLl25","moneyManagement":"navbar_moneyManagement__FyAkd"};